var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.conditions, function(group, groupIndex) {
        return _c(
          "div",
          { key: group.id, staticClass: "group-container" },
          [
            _c("div", { staticClass: "text-right btn-delete-group-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-danger btn-delete-group",
                  attrs: { disabled: !_vm.canWrite },
                  on: {
                    click: function($event) {
                      return _vm.deleteGroup(groupIndex)
                    }
                  }
                },
                [_c("i", { staticClass: "far fa-trash-alt" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "overlay-mask" }),
              _vm._v(" "),
              _c("div", {
                staticClass: "overlay-border",
                class: { disabled: !_vm.canWrite }
              })
            ]),
            _vm._v(" "),
            _vm._l(group.children, function(condition, conditionIndex) {
              return _c("brick-filter-condition", {
                key: condition.id,
                ref: "conditions",
                refInFor: true,
                staticClass: "group-item",
                attrs: {
                  field: condition.field,
                  value: condition.value,
                  "can-write": _vm.canWrite,
                  "included-category-filters": _vm.includedCategoryFilters,
                  "excluded-category-filters": _vm.excludedCategoryFilters
                },
                on: {
                  "update:value": function($event) {
                    return _vm.setValue(condition, $event)
                  },
                  "update:field": function($event) {
                    return _vm.setField(condition, $event)
                  },
                  deleteCondition: function($event) {
                    return _vm.deleteCondition(groupIndex, conditionIndex)
                  }
                }
              })
            }),
            _vm._v(" "),
            _vm.canWrite
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-primary btn btn-add-condition",
                    on: {
                      click: function($event) {
                        return _vm.addCondition(groupIndex)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            + " +
                        _vm._s(
                          _vm.resource(
                            "JourneyComposer_FilterModal_AddCondition"
                          )
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.canWrite
        ? _c(
            "button",
            {
              staticClass: "btn btn-outline-primary btn btn-add-group",
              on: {
                click: function($event) {
                  return _vm.addGroup()
                }
              }
            },
            [
              _vm._v(
                "\n        + " +
                  _vm._s(_vm.resource("JourneyComposer_FilterModal_AddGroup")) +
                  "\n    "
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }